import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { IconosService } from './services/registro-iconos/iconos.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { LoaderComponent } from "./shared/loader/loader.component";
import { AuthService, UserData } from './services/autenticacion/auth..service';
import { ChangeThemeService } from './services/cambio-tema/change-theme.service';
import { LoaderService } from './services/loader/loader.service';
import { lastValueFrom } from 'rxjs';
import { ModalService } from './services/modal/modal.service';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HttpClientModule, MatIconModule, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'HealthBook';
  iconsLoaded = false;
  constructor(private iconosService: IconosService,
    private hhtpclient: HttpClient,
    private changueThemeSVC: ChangeThemeService,
    private loadersvc: LoaderService,
    private location: Location,
    private authSvc: AuthService,
    private modalService: ModalService,
    private router: Router,
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
  }

  async ngAfterContentInit(): Promise<void> {
    await this.changueThemeSVC.consultUserTheme();
  }

  async ngOnInit() {
    this.matIconRegistry.addSvgIcon('errormodal', this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/iconos/errormodal.svg')
    );
    // Esto asegurará que el servicio se inicialice y los íconos se registren
    await this.verifysessionAndToken();
    this.loadersvc.show()
    this.loadersvc.text.set({ text: 'Cargando contenido' })
    await this.iconosService.loadIcons().then(async () => {
      this.iconsLoaded = true; // Cambia el estado para que se renderice el contenido
      this.loadersvc.hide()
    }).catch((error) => {
      this.loadersvc.hide()
      console.error('Error al cargar los iconos', error);
      this.iconsLoaded = true; // Aun si hay error, se muestra el contenido
    });
  }

  // Funcionalidad para hacer que cuando inicie la aplicación y el path de ruta incluya inicio entonces dispare el traer token refresh
  private async verifysessionAndToken() {
    //Verificamos sesión con cookie
    let session = await this.verifySession();
    if (session) {
      await this.handleToken();
    } else {
      return
    }
    const at = this.authSvc.getAccessToken();
    const currentPath = this.location.path();
    if (at && (currentPath.startsWith('/login') || currentPath == '')) {
      this.router.navigate(['/inicio']);

    }

  }

  private async verifySession(): Promise<boolean> {
    try {
      this.loadersvc.show();
      this.loadersvc.text.set({ text: 'Verificando sesión' });
      const session : any = this.authSvc.readUserData();
      this.loadersvc.hide();
      if (session && session.idUser) {
        return true;
      }
    } catch (error) { }
    this.authSvc.logout(false, false);
    return false;
  }

  async handleToken() {
    try {
      this.loadersvc.show()
      this.loadersvc.text.set({ text: 'Verificando datos de sesión' })
      let token = await lastValueFrom(this.authSvc.refreshTokenService());
      this.loadersvc.hide()
      if (token.ok) {
        return this.authSvc.setAcessToken(token.data)
      }
    } catch (error) {
      this.loadersvc.hide()

    }
    return this.authSvc.logout(true, true);
  }



}
